import type { RouteViewModelStop, RouteViewModelStopExecution } from '../../types/routeViewModel';

export function getStopExecutionSlice(
  stop: RouteViewModelStop | Record<string, unknown> | null | undefined
): RouteViewModelStopExecution | null {
  if (!stop || typeof stop !== 'object') return null;
  const execution = (stop as RouteViewModelStop).execution;
  if (!execution || typeof execution !== 'object') return null;
  return execution;
}

/** Actual datetime for display — execution slice only (RouteView DTO). */
export function getStopExecutionActualAt(
  stop: RouteViewModelStop | Record<string, unknown> | null | undefined
): string | null {
  const slice = getStopExecutionSlice(stop);
  if (slice?.actualAt) return slice.actualAt;
  const projected = (stop as RouteViewModelStop | undefined)?.actualAt;
  return typeof projected === 'string' && projected.trim() ? projected : null;
}

export function getStopExecutionState(
  stop: RouteViewModelStop | Record<string, unknown> | null | undefined
): string | null {
  const raw = getStopExecutionSlice(stop)?.executionState;
  return raw != null && String(raw).trim() !== '' ? String(raw) : null;
}
